import * as React from "react";
import {Container, Nav, Tab} from "react-bootstrap";
import {StatusPage} from "./Status";
import {LogsPage} from "./Logs";
import {Route, Routes, useLocation, useNavigate, useParams} from "react-router";
import {Api} from "../../../_api";
import {ConfigPage} from "./Config";
import {useEffect} from "react";

export const PumpNDumpBotPage = () => {
    let {exchange, account} = useParams();
    const exchangeApi = Api.forExchangeAccount(exchange, account)
    const botApi = exchangeApi.forBot("pump-n-dump")
    const baseUrl = `/exchange/${exchange}/accounts/${account}/bot/pump-n-dump`

    const location = useLocation()
    const navigate = useNavigate()

    const activeTab = location.pathname.split("/")[7];

    useEffect(() => {
        if (typeof activeTab === 'undefined') {
            navigate(`${baseUrl}/status`)
        }
    }, [activeTab, baseUrl, navigate]);

    return <Container fluid>
        <div id="pump-n-dumpBot">
            <h3>[{exchange} ({account})] Pump&Dump Bot</h3>
            <Tab.Container id={"pump-n-dump-bot"} onSelect={k => {
                navigate(`${baseUrl}/${k}`)
            }} defaultActiveKey={activeTab} activeKey={activeTab}>
                <Nav variant="tabs">
                    <Nav.Item>
                        <Nav.Link eventKey={"status"}>{"Status"}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey={"config"}>{"Configuration"}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey={"logs"}>{"Logs"}</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Routes>
                        <Route path={"/status"} element={<Tab.Pane eventKey={"status"}>
                            <StatusPage key={Date.now()} exchange={exchange} account={account}
                                        exchangeApi={exchangeApi} botApi={botApi}/>
                        </Tab.Pane>}/>
                        <Route path={"/config"} element={<Tab.Pane eventKey={"config"}>
                            <ConfigPage key={Date.now()} exchange={exchange} account={account}
                                        exchangeApi={exchangeApi} botApi={botApi}/>
                        </Tab.Pane>}/>
                        <Route path={"/logs"} element={<Tab.Pane eventKey={"logs"}>
                            <LogsPage key={Date.now()} exchange={exchange} account={account}
                                      api={botApi}/>
                        </Tab.Pane>}/>
                    </Routes>
                </Tab.Content>
            </Tab.Container>
        </div>
    </Container>;
}
